/** @jsx jsx */
import { jsx } from "@emotion/react";
import {
  AccountCircle,
  ExpandLess,
  ExpandMore,
  SupervisorAccount,
} from "@material-ui/icons";
import { FC } from "react";
import { useServerPersonalizationData } from "src/store/personalization/useSelectors";
import useChangedStateOnOutsideClick from "../../../../../utils/useChangedStateOnOutsideClick";
import LogOutSection from "../../../LogOutSection";
import { getIconCss } from "../../styles";
import {
  AccountCollapse,
  accountContainerCss,
  AccountWrapperBtn,
  BugIcon,
  ListItem,
} from "./styles";

type Props = {
  isImpersonating: boolean;
  unreportedBugsCount: number;
  hasFlowioBugs: boolean;
  invokeBugReportModal: () => void;
  invokeFeedbackModal: () => void;
  invokePasswordChangeModal: () => void;
  invokeBugOverviewModal: () => void;
};

const Account: FC<Props> = ({
  unreportedBugsCount,
  isImpersonating,
  hasFlowioBugs,
  invokeBugReportModal,
  invokeBugOverviewModal,
  invokeFeedbackModal,
  invokePasswordChangeModal,
}) => {
  const { ref, isOpen, setIsOpen } =
    useChangedStateOnOutsideClick<HTMLDivElement>();
  const personalizationData = useServerPersonalizationData();

  const accountIcon = isImpersonating ? (
    <SupervisorAccount css={getIconCss(isOpen, true)} />
  ) : (
    <AccountCircle css={getIconCss(isOpen, false)} />
  );

  const expandIcon = isOpen ? (
    <ExpandLess css={getIconCss(true, isImpersonating)} />
  ) : (
    <ExpandMore css={getIconCss(false, isImpersonating)} />
  );

  return (
    <ListItem data-cy="accouunt-menu-link">
      <div css={accountContainerCss} ref={ref}>
        <AccountWrapperBtn id="tour-login" onClick={() => setIsOpen(!isOpen)}>
          {accountIcon}
          {expandIcon}
          {Boolean(unreportedBugsCount) && <BugIcon />}
        </AccountWrapperBtn>

        {isOpen && (
          <AccountCollapse isOpen={isOpen}>
            <LogOutSection
              invokeBugReportModal={invokeBugReportModal}
              invokeBugOverviewModal={invokeBugOverviewModal}
              invokeFeedbackModal={invokeFeedbackModal}
              invokePasswordChangeModal={invokePasswordChangeModal}
              personalizationData={personalizationData}
              unreportedBugsCount={unreportedBugsCount}
              hasFlowioBugs={hasFlowioBugs}
            />
          </AccountCollapse>
        )}
      </div>
    </ListItem>
  );
};

export default Account;
export type AccountProps = Props;
